<template>
  <v-row class="fill-height" fluid>
    <v-container fluid>
      <v-subheader class="mb-5">
        <h1>Planificación de citas</h1>
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="5">
          <v-row align="center">
            <v-col cols="12" align="center">
              <v-date-picker
                :disabled="!vista.escritura || loading"
                color="primary"
                elevation="15"
                full-width
                locale="es-PE"
                v-model="fecha"
                style="max-width: 400px;"
              ></v-date-picker>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="7">
          <v-container>
            <v-row align="center">
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Fecha</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">
                  {{
                    parseFecha(fecha).toLocaleString("es-PE", {
                      dateStyle: "long"
                    })
                  }}
                </span>
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Estado</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <v-chip
                  v-if="estadoDesc != ''"
                  class="ml-5 align-self-center"
                  :color="colorEstado"
                  text-color="white"
                >
                  {{ this.estadoDesc }}</v-chip
                >
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Tope citas</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ maximo }}</span>
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Registrado</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ registrado }}</span>
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Por asignar</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ asignable }}</span>
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Asignado</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <span class="ml-5 align-self-center">{{ asignado }}</span>
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex justify-end">
                <label
                  class="align-self-center mr-5"
                  style="text-align: right;"
                >
                  Activo</label
                >:
              </v-col>
              <v-col cols="3" sm="6" md="3" class="pa-1 d-flex">
                <v-switch
                  :disabled="!vista.escritura || loading || cerrado"
                  @change="activar()"
                  class="ma-0 ml-5 align-self-center"
                  dense
                  hide-details
                  v-model="activo"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-data-table
                  :headers="headers"
                  :items="tipos"
                  :loading="loading"
                  class="elevation-1"
                  dense
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.maximo="{ item }">
                    <div v-if="!cerrado" class="d-inline-flex justify-center">
                      <v-btn
                        :disabled="
                          !vista.escritura ||
                            loading ||
                            cerrado ||
                            asignable <= 0
                        "
                        @click.stop="agregar(item)"
                        class="align-self-center"
                        x-small
                      >
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-text-field
                        :disabled="
                          !vista.escritura ||
                            loading ||
                            cerrado ||
                            asignable <= 0
                        "
                        @change.native="validarMaximo(item)"
                        class="contador mr-1 ml-1 mb-1 align-self-center"
                        dense
                        hide-details
                        style="width: 40px;"
                        type="number"
                        v-model="item.maximo"
                      ></v-text-field>
                      <v-btn
                        :disabled="
                          !vista.escritura ||
                            loading ||
                            cerrado ||
                            item.maximo <= 0 ||
                            item.maximo <= item.registrado ||
                            item.maximo - item.registrado < item.cupoAsignado
                        "
                        @click.stop="quitar(item)"
                        class="align-self-center"
                        x-small
                      >
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                    <span
                      v-else
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                    >
                      {{ item.maximo }}
                    </span>
                  </template>
                  <template v-slot:item.registrado="{ item }">
                    <span
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                    >
                      {{ item.registrado }}
                    </span>
                  </template>
                  <template v-slot:item.disponible="{ item }">
                    <span
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                    >
                      {{ item.maximo - item.registrado }}</span
                    >
                  </template>
                  <template v-slot:item.cupoAsignado="{ item }">
                    <span
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                    >
                      {{ item.cupoAsignado }}</span
                    >
                  </template>
                  <template v-slot:item.rangos="{ item }">
                    <v-btn
                      :disabled="loading || item.rangos.length == 0"
                      @click.stop="mostrarRangos(item)"
                      class="align-self-center"
                      icon
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.estado="{ item }">
                    <div :disabled="cerrado">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            :color="
                              cerrado
                                ? ''
                                : item.maximo - item.registrado > 0
                                ? 'success'
                                : 'error'
                            "
                            class="align-self-center"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>
                          {{
                            cerrado
                              ? "No definido"
                              : item.maximo - item.registrado > 0
                              ? "Disponible"
                              : "Ocupado"
                          }}
                        </span>
                      </v-tooltip>
                    </div>
                  </template>

                  <!-- <template v-slot:item.rangosAct="{ item }">
                    <span
                      class="d-inline-flex justify-center"
                      style="width: 100%;"
                      >{{
                        item.rangosSelec.length + "/" + item.rangos.length
                      }}</span
                    >
                  </template> -->
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <br />
      <v-btn
        v-if="vista.escritura && !cerrado && estado != ''"
        :loading="loading"
        fab
        dark
        large
        color="primary"
        fixed
        right
        bottom
        @click="guardar()"
      >
        <v-icon dark>save</v-icon>
      </v-btn>
      <v-dialog v-model="dialogo.open" persistent max-width="450px">
        <v-card>
          <v-card-title>
            <span class="headline">Horarios - {{ dialogo.tipoMant }}</span>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-list>
              <v-subheader class="pa-0">
                Cupos disponibles: {{ dialogo.maximo - dialogo.cupoAsignado }}
              </v-subheader>
              <v-list-item-group
                v-model="dialogo.rangosSelec"
                multiple
                style="max-height: 300px;"
                class="overflow-y-auto"
              >
                <v-list-item
                  v-for="(item, i) in dialogo.rangos"
                  :key="i"
                  :disabled="!vista.escritura || loading || cerrado"
                >
                  <template v-slot:default="{ active }">
                    {{ i + 1 }}.
                    <v-list-item-content>
                      <v-list-item-title style="text-align: center;">
                        {{ tiempo(item.hora_inicio, item.minuto_inicio) }}
                        -
                        {{ tiempo(item.hora_fin, item.minuto_fin) }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="ml-0">
                      <v-checkbox
                        :disabled="!vista.escritura || loading || cerrado"
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <div
                      style="margin-left: 40px !important;"
                      class="d-inline-flex justify-center"
                      @click.stop
                      @mousedown.stop
                    >
                      <v-btn
                        :disabled="
                          !vista.escritura ||
                            loading ||
                            cerrado ||
                            !active ||
                            dialogo.maximo <= dialogo.cupoAsignado
                        "
                        @click.stop="agregar2(item)"
                        @mousedown.stop
                        class="align-self-center"
                        x-small
                      >
                        <v-icon small>mdi-plus</v-icon>
                      </v-btn>
                      <v-text-field
                        :disabled="
                          !vista.escritura || loading || cerrado || !active
                        "
                        v-model="item.cupos"
                        dense
                        hide-details
                        class="ma-0 contador"
                        type="number"
                        style="max-width: 40px;"
                        @click.stop
                        @mousedown.stop
                        @input.native="validarCupos(item)"
                      ></v-text-field>
                      <v-btn
                        :disabled="
                          !vista.escritura ||
                            loading ||
                            cerrado ||
                            !active ||
                            item.cupos <= 0 ||
                            item.cupos <= item.registrado
                        "
                        @click.stop="quitar2(item)"
                        @mousedown.stop
                        class="align-self-center"
                        x-small
                      >
                        <v-icon small>mdi-minus</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.stop="cerrarRangos()">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";

const FECHA_HOY = new Date();
FECHA_HOY.setHours(0, 0, 0, 0);
export default {
  name: "Planificacion",
  data: () => ({
    fecha: "",
    loading: false,
    estado: "",
    estadoDesc: "",
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "correlativo"
      },
      { text: "Descripción", value: "descripcion", sortable: false },
      { text: "Asignado", value: "maximo", sortable: false },
      { text: "Registrado", value: "registrado", sortable: false },
      { text: "Disponible", value: "disponible", sortable: false },
      { text: "Cupos. Asig.", value: "cupoAsignado", sortable: false },
      { text: "Horarios", value: "rangos", sortable: false },
      { text: "Estado", value: "estado", sortable: false }
      // { text: "H. Activos", value: "rangosAct", sortable: false }
    ],
    activo: false,
    maximo: 0,
    asignado: 0,
    asignable: 0,
    registrado: 0,
    tipos: [],
    dialogo: {
      open: false,
      corr: "",
      rangos: [],
      rangosSelec: [],
      maximo: 0,
      cupoAsignado: 0,
      tipoMant: ""
    },
    vista: {}
  }),
  watch: {
    fecha(valor) {
      this.obtenerPlanificacion(valor);
    }
  },
  computed: {
    ...mapGetters(["getToken"]),
    colorEstado() {
      switch (this.estado) {
        case "A":
          return "success";
        case "B":
          return "warning";
        case "C":
          return "error";
        default:
          return "";
      }
    },
    cerrado() {
      return this.estado == "C";
    }
  },
  methods: {
    ...mapActions(["setToken", "showAlerta2", "hideAlerta2"]),
    tiempo(dia, hora) {
      let diaStr = "00" + dia;
      let horaStr = "00" + hora;
      return (
        diaStr.substr(diaStr.length - 2) +
        ":" +
        horaStr.substr(horaStr.length - 2)
      );
    },
    numero(valor) {
      let numero = parseFloat(valor);

      if (
        isNaN(numero) ||
        numero < 0 ||
        numero == null ||
        numero == undefined
      ) {
        numero = 0;
      }

      return numero;
    },
    async loadVista() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/usuario/ObtenerVista?vista=PLANIFICACION`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.vista = respuesta.data;
    },
    agregar(item) {
      item.maximo++;
      item.maximoAnt = item.maximo;
      this.asignable--;
      this.asignado++;
    },
    quitar(item) {
      item.maximo--;
      item.maximoAnt = item.maximo;
      this.asignable++;
      this.asignado--;
    },
    agregar2(item) {
      item.cupos++;
      this.dialogo.cupoAsignado++;
    },
    quitar2(item) {
      item.cupos--;
      this.dialogo.cupoAsignado--;
    },
    parseFecha(date) {
      const partes = date.split("-");
      const fecha = new Date(partes[0], partes[1] - 1, partes[2]);
      return fecha;
    },
    activar() {
      if (this.activo) {
        this.estado = "A";
        this.estadoDesc = "Activo";
      } else {
        this.estado = "B";
        this.estadoDesc = "Bloqueado";
      }
    },
    validarMaximo(item) {
      if (item.maximo <= 0) {
        item.maximo = 0;
      }

      if (this.asignable < item.maximo - item.maximoAnt) {
        item.maximo = item.maximoAnt;
      } else if (item.maximo < item.registrado) {
        item.maximo = item.maximoAnt;
      } else if (item.maximo - item.registrado < item.cupoAsignado) {
        item.maximo = item.maximoAnt;
      }

      const diferencia = item.maximo - item.maximoAnt;
      this.asignado += diferencia;
      this.asignable -= diferencia;
      item.maximoAnt = item.maximo;
    },
    validarCupos(item) {
      if (item.cupos <= 0) {
        item.cupos = 0;
      }

      if (
        this.dialogo.maximo - this.dialogo.cupoAsignado <
        item.cupos - item.cuposAnt
      ) {
        item.cupos = item.cuposAnt;
      }
      const diferencia = item.cupos - item.cuposAnt;
      this.dialogo.cupoAsignado += diferencia;
      item.cuposAnt = item.cupos;
    },
    async obtenerPlanificacion(fecha) {
      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH +
            `/api/planificacion/obtener?fecha=${fecha}`,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }

        return;
      } finally {
        this.loading = false;
      }

      // console.log(respuesta.data);

      this.activo = respuesta.data.activo;
      this.nuevo = respuesta.data.nuevo;
      this.estado = respuesta.data.estado;
      this.estadoDesc = respuesta.data.estado_descripcion;
      let totalRegistrado = 0;
      let totalAsignado = 0;

      this.tipos = respuesta.data.tipos.map((el, idx) => {
        totalAsignado += el.maximo;
        totalRegistrado += el.registrado;
        el.rangos = Array.isArray(el.rangos) ? el.rangos : [];

        let rangosSelec = [];

        el.cupoAsignado = 0;

        el.rangos.forEach((val, idx, arr) => {
          if (val.activo) {
            rangosSelec.push(idx);
          }
          el.cupoAsignado += val.cupos;
          val.cuposAnt = val.cupos;
        });

        el.rangosSelec = rangosSelec;

        return {
          ...el,
          correlativo: idx + 1,
          maximoAnt: el.maximo,
          rangosAct: null
        };
      });

      this.maximo = respuesta.data.maximo;
      this.registrado = totalRegistrado;
      this.asignado = totalAsignado;
      this.asignable = respuesta.data.maximo - totalAsignado;
    },
    async guardar() {
      if (this.loading) {
        return;
      }

      const params = {
        fecha_formato: this.fecha,
        nuevo: this.nuevo,
        tipos: this.tipos,
        maximo: this.maximo,
        activo: this.activo
      };
      // console.log(params);
      // return;
      let respuesta;
      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/planificacion/Guardar",
          params,
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      } finally {
        this.loading = false;
      }
      if (this.nuevo) {
        this.activo = true;
        this.nuevo = false;
        this.estado = "A";
        this.estadoDesc = "Activo";
      }

      this.showAlerta2({
        mensaje: respuesta.data.mensaje,
        tipo: respuesta.data.tipo
      });
    },
    mostrarRangos(item) {
      console.log(item);
      this.dialogo.corr = item.correlativo;
      this.dialogo.rangos = item.rangos;
      this.dialogo.rangosSelec = item.rangosSelec;
      this.dialogo.tipoMant = item.descripcion;
      this.dialogo.maximo = item.maximo;
      this.dialogo.cupoAsignado = item.cupoAsignado;
      this.dialogo.open = true;
    },
    cerrarRangos() {
      this.dialogo.open = false;
      let item = this.tipos.find(x => x.correlativo == this.dialogo.corr);
      if (item) {
        item.rangosSelec = this.dialogo.rangosSelec;
        item.cupoAsignado = this.dialogo.cupoAsignado;
        item.rangos.forEach((val, idx, arr) => {
          val.activo = item.rangosSelec.some(x => x == idx);
        });

        console.log(item);
      }
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    this.loadVista();
    this.fecha = FECHA_HOY.toISOString().substr(0, 10);
  }
};
</script>

<style>
.contador input::-webkit-outer-spin-button,
.contador input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

/* Firefox */
.contador input[type="number"] {
  -moz-appearance: textfield !important;
  text-align: center;
  font-size: 14px;
}

/* .v-list .v-text-field__slot input[type="number"] {
  text-align: right;
} */</style
>;
